import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PaymentComponent } from './payment.component';
import {
  PaymentResolver,
  PaymentResultResolver,
  TransportationResolver,
} from './resolvers';
import { ShoppingCartOrdersResolver } from 'src/app/shared';
import { UserResolver } from '../landing/resolvers/user.resolver';
import { ResultComponent } from './components';

const routes: Routes = [
  {
    path: '',
    component: PaymentComponent,
    resolve: {
      transportationMethods: TransportationResolver,
      orders: ShoppingCartOrdersResolver,
      payment: PaymentResolver,
      user: UserResolver,
    },
  },
  {
    path: 'result/:status/:id',
    component: ResultComponent,
    // resolve: {
    //   payment: PaymentResultResolver,
    // },
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentRoutingModule {}
